import { Component, computed, input, output } from '@angular/core';

export type ChipColor = 'default' | 'info' | 'success' | 'primary' | 'warning' | 'danger';

type ChipSize = 'sm' | 'md' | 'lg';

type ChipFill = 'filled' | 'outline';

@Component({
  selector: 'app-pan-chip',
  templateUrl: './pan-chip.component.html',
  styleUrl: './pan-chip.component.scss',
  standalone: false,
})
export class PanChipComponent {
  public label = input<string>('');
  public color = input<ChipColor>('default');
  public size = input<ChipSize>('md');
  public fill = input<ChipFill>('filled');
  public width = input<number>();
  public canRemove = input<boolean>(false);
  public remove = output<void>();

  public classes = computed(() => {
    return [
      'chip',
      `chip-color-${this.color()}`,
      `chip-fill-${this.fill()}`,
      `chip-size-${this.size()}`,
      this.width() ? `min-w-[${this.width()}px]` : '',
    ];
  });
}
